<template>
    <div class="Panel">
        <div class="Panel__heading">User Import</div>
        <div class="Panel__body">
            <p>
                To import a list of users you must first
                <a href="/system-settings/account-management/import/download/users">download this template</a>. Next
                make the required changes, save the file and re-upload here.
            </p>


        </div>
    </div>
</template>

<script>
    export default {

    }
</script>